<template>
    <div class="wrapper">
        <takeda-logo />

        <div class="container-wrapper">
            <preloader :dotColor="'linear-gradient(270.22deg, #F9A900 10.58%, #FF7DA5 140.06%)'" v-if="isPreloaderOn" />

            <div class="container" v-else>
                <div class="head">
                    Увійти
                </div>

                <div class="description">
                    Введіть логін і пароль, отримані від представника компанії <b>Takeda</b>
                </div>

                <div class="item">
                    <div class="item-name">
                        Логін*
                    </div>
                    <div class="item-value" :class="isLoginError ? 'error' : ''">
                        <input class="text-input" type="text" v-model="login" @input="resetLoginError()" placeholder="email.example@yourmail.com" ref="login">
                    </div>
                    <div class="error-block-login" v-if="errors.log">
                        <div class="icon">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.6736 12.4688L11.0223 1.15625C10.5871 0.4375 9.84119 0 9.002 0C8.1628 0 7.41686 0.4375 6.98172 1.15625L0.330346 12.4688C-0.104791 13.1875 -0.104791 14.0938 0.299264 14.8125C0.734401 15.5625 1.48035 16 2.31954 16H15.6534C16.4926 16 17.2696 15.5625 17.6736 14.8125C18.1088 14.0938 18.1088 13.1875 17.6736 12.4688ZM16.8966 14.3438C16.648 14.7813 16.1817 15.0625 15.6845 15.0625H2.31954C1.82224 15.0625 1.35602 14.8125 1.10738 14.3438C0.858726 13.9063 0.858726 13.375 1.10738 12.9375L7.78983 1.625C8.03848 1.1875 8.5047 0.9375 9.002 0.9375C9.4993 0.9375 9.96551 1.1875 10.2142 1.625L16.8966 12.9375C17.1453 13.375 17.1453 13.9063 16.8966 14.3438Z" fill="#B30037"/>
                                <path d="M9.00199 4.31253C8.6601 4.31253 8.38037 4.59378 8.38037 4.93753V9.93753C8.38037 10.2813 8.6601 10.5625 9.00199 10.5625C9.34389 10.5625 9.62362 10.2813 9.62362 9.93753V4.93753C9.62362 4.59378 9.34389 4.31253 9.00199 4.31253Z" fill="#B30037"/>
                                <path d="M9.00199 11.6875C8.6601 11.6875 8.38037 11.9688 8.38037 12.3125V12.625C8.38037 12.9688 8.6601 13.25 9.00199 13.25C9.34389 13.25 9.62362 12.9688 9.62362 12.625V12.3125C9.62362 11.9375 9.34389 11.6875 9.00199 11.6875Z" fill="#B30037"/>
                            </svg>
                        </div>
                        <div class="text">
                            <p>Щоб увійти, треба ввести логін</p>
                        </div>
                    </div>
                </div>

                <div class="item">
                    <div class="item-name">
                        Пароль*
                    </div>
                    <div class="item-value with-icon" :class="isPasswordError ? 'error' : ''">
                        <input class="password-input" type="password" v-model="password" @input="resetPasswordError()" placeholder="password_example" ref="password">
                        <div class="visible-block" @click="changePasswordVisibility()">

                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#555555" width="28px" height="28px" v-if="!isPasswordVisible">
                                <g opacity="0.3">
                                    <path d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z" fill="none"/>
                                    <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
                                </g>
                            </svg>


                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#555555" width="28px" height="28px" v-if="isPasswordVisible">
                                <g opacity="0.3">
                                    <path d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                                </g>
                            </svg>

                        </div>
                    </div>
                    <div class="error-block-login" v-if="errors.log_pas">
                        <div class="icon">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.6736 12.4688L11.0223 1.15625C10.5871 0.4375 9.84119 0 9.002 0C8.1628 0 7.41686 0.4375 6.98172 1.15625L0.330346 12.4688C-0.104791 13.1875 -0.104791 14.0938 0.299264 14.8125C0.734401 15.5625 1.48035 16 2.31954 16H15.6534C16.4926 16 17.2696 15.5625 17.6736 14.8125C18.1088 14.0938 18.1088 13.1875 17.6736 12.4688ZM16.8966 14.3438C16.648 14.7813 16.1817 15.0625 15.6845 15.0625H2.31954C1.82224 15.0625 1.35602 14.8125 1.10738 14.3438C0.858726 13.9063 0.858726 13.375 1.10738 12.9375L7.78983 1.625C8.03848 1.1875 8.5047 0.9375 9.002 0.9375C9.4993 0.9375 9.96551 1.1875 10.2142 1.625L16.8966 12.9375C17.1453 13.375 17.1453 13.9063 16.8966 14.3438Z" fill="#B30037"/>
                                <path d="M9.00199 4.31253C8.6601 4.31253 8.38037 4.59378 8.38037 4.93753V9.93753C8.38037 10.2813 8.6601 10.5625 9.00199 10.5625C9.34389 10.5625 9.62362 10.2813 9.62362 9.93753V4.93753C9.62362 4.59378 9.34389 4.31253 9.00199 4.31253Z" fill="#B30037"/>
                                <path d="M9.00199 11.6875C8.6601 11.6875 8.38037 11.9688 8.38037 12.3125V12.625C8.38037 12.9688 8.6601 13.25 9.00199 13.25C9.34389 13.25 9.62362 12.9688 9.62362 12.625V12.3125C9.62362 11.9375 9.34389 11.6875 9.00199 11.6875Z" fill="#B30037"/>
                            </svg>
                        </div>
                        <div class="text">
                            <p v-if="errors.log_pas">Щоб увійти, треба ввести логін і пароль</p>
                        </div>
                    </div>
                    <div class="error-block-login" v-if="errors.pas">
                        <div class="icon">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.6736 12.4688L11.0223 1.15625C10.5871 0.4375 9.84119 0 9.002 0C8.1628 0 7.41686 0.4375 6.98172 1.15625L0.330346 12.4688C-0.104791 13.1875 -0.104791 14.0938 0.299264 14.8125C0.734401 15.5625 1.48035 16 2.31954 16H15.6534C16.4926 16 17.2696 15.5625 17.6736 14.8125C18.1088 14.0938 18.1088 13.1875 17.6736 12.4688ZM16.8966 14.3438C16.648 14.7813 16.1817 15.0625 15.6845 15.0625H2.31954C1.82224 15.0625 1.35602 14.8125 1.10738 14.3438C0.858726 13.9063 0.858726 13.375 1.10738 12.9375L7.78983 1.625C8.03848 1.1875 8.5047 0.9375 9.002 0.9375C9.4993 0.9375 9.96551 1.1875 10.2142 1.625L16.8966 12.9375C17.1453 13.375 17.1453 13.9063 16.8966 14.3438Z" fill="#B30037"/>
                                <path d="M9.00199 4.31253C8.6601 4.31253 8.38037 4.59378 8.38037 4.93753V9.93753C8.38037 10.2813 8.6601 10.5625 9.00199 10.5625C9.34389 10.5625 9.62362 10.2813 9.62362 9.93753V4.93753C9.62362 4.59378 9.34389 4.31253 9.00199 4.31253Z" fill="#B30037"/>
                                <path d="M9.00199 11.6875C8.6601 11.6875 8.38037 11.9688 8.38037 12.3125V12.625C8.38037 12.9688 8.6601 13.25 9.00199 13.25C9.34389 13.25 9.62362 12.9688 9.62362 12.625V12.3125C9.62362 11.9375 9.34389 11.6875 9.00199 11.6875Z" fill="#B30037"/>
                            </svg>
                        </div>
                        <div class="text">
                            <p v-if="errors.pas">Щоб увійти, треба ввести пароль</p>
                        </div>
                    </div>
                    <div class="error-block-login" v-if="errors.auth">
                        <div class="icon">
                            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.6736 12.4688L11.0223 1.15625C10.5871 0.4375 9.84119 0 9.002 0C8.1628 0 7.41686 0.4375 6.98172 1.15625L0.330346 12.4688C-0.104791 13.1875 -0.104791 14.0938 0.299264 14.8125C0.734401 15.5625 1.48035 16 2.31954 16H15.6534C16.4926 16 17.2696 15.5625 17.6736 14.8125C18.1088 14.0938 18.1088 13.1875 17.6736 12.4688ZM16.8966 14.3438C16.648 14.7813 16.1817 15.0625 15.6845 15.0625H2.31954C1.82224 15.0625 1.35602 14.8125 1.10738 14.3438C0.858726 13.9063 0.858726 13.375 1.10738 12.9375L7.78983 1.625C8.03848 1.1875 8.5047 0.9375 9.002 0.9375C9.4993 0.9375 9.96551 1.1875 10.2142 1.625L16.8966 12.9375C17.1453 13.375 17.1453 13.9063 16.8966 14.3438Z" fill="#B30037"/>
                                <path d="M9.00199 4.31253C8.6601 4.31253 8.38037 4.59378 8.38037 4.93753V9.93753C8.38037 10.2813 8.6601 10.5625 9.00199 10.5625C9.34389 10.5625 9.62362 10.2813 9.62362 9.93753V4.93753C9.62362 4.59378 9.34389 4.31253 9.00199 4.31253Z" fill="#B30037"/>
                                <path d="M9.00199 11.6875C8.6601 11.6875 8.38037 11.9688 8.38037 12.3125V12.625C8.38037 12.9688 8.6601 13.25 9.00199 13.25C9.34389 13.25 9.62362 12.9688 9.62362 12.625V12.3125C9.62362 11.9375 9.34389 11.6875 9.00199 11.6875Z" fill="#B30037"/>
                            </svg>
                        </div>
                        <div class="text">
                            <p v-if="errors.auth">Невірно вказаний логін або пароль</p>
                        </div>
                    </div>
                </div>

                <button class="enter" :class="!isValidationPassed ? 'disabled' : ''" @click="checkLoginData()">Увійти</button>               
            </div>
        </div>     
    </div>
</template>

<script>
import axios from 'axios';
import Preloader from '../components/Preloader';
import TakedaLogo from '../components/TakedaLogo';

export default {
    components : {
        'takeda-logo' : TakedaLogo,
        'preloader' : Preloader
    },
    data : () => ({
        isPreloaderOn : false,
        isPasswordVisible : false,
        isValidationPassed : false,
        login : '',
        password : '',
        isLoginError : false,
        isPasswordError : false,
        errors : {
            log_pas : false,
            log : false,
            pas : false,
            auth : false
        }
    }),
    methods : {
        changePasswordVisibility(){
            if(this.isPasswordVisible){
                this.$refs.password.type = "password";
                this.$refs.password.focus();
            }
            else{
                this.$refs.password.type = "text";
                this.$refs.password.focus();
            }

            this.isPasswordVisible = !this.isPasswordVisible;
        },
        checkIsValidationPassed(){
            if(this.errors.log_pas || this.errors.log || this.errors.pas || this.login === '' || this.password === '')
                this.isValidationPassed = false;
            else
                this.isValidationPassed = true;
        },
        resetLoginError(){
            this.isLoginError = false;
            this.errors.log = false;
            this.errors.log_pas = false;
            this.errors.auth = false;

            this.checkIsValidationPassed();
        },
        resetPasswordError(){
            this.isPasswordError = false;
            this.errors.pas = false;
            this.errors.log_pas = false;
            this.errors.auth = false;

            this.checkIsValidationPassed();
        },
        checkFieldsNotEmpty(){
            if(this.login === '' && this.password === ''){
                this.isLoginError = true;
                this.isPasswordError = true;
                this.errors.log_pas = true;

                return false;
            }

            if(this.login === ''){
                this.isLoginError = true;
                this.errors.log = true;

                return false;
            }

            if(this.password === ''){
                this.isPasswordError = true;
                this.errors.pas = true;

                return false;
            }

            return true;
        },
        checkLoginData(){
            if(!this.checkFieldsNotEmpty())
                return false;

            this.isLoginError = false;
            this.isPasswordError = false;

            this.isPreloaderOn = true;

            axios.post('api/Account', { login : this.login, password : this.password })
            .then(response => {
                if(response.data.status === 'Error'){
                    this.isLoginError = true;
                    this.isPasswordError = true;
                    this.errors.auth = true;
                }

                sessionStorage.setItem('access_token', response.data.access_token);
                sessionStorage.setItem('role', response.data.role);

                if(response.data.role === 'admin'){
                    this.$router.push('/patients');
                }

                if(response.data.role === 'superAdmin'){
                    this.$router.push('/admin');
                }


                this.isPreloaderOn = false;
            })
        }
    }
}
</script>

<style lang="scss">
.webp{
    .wrapper{
        background: url("../assets/images/moderator/login/login-bg.webp");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
}

.wrapper{
    width: 100%;
    height: 100%;
    background: url("../assets/images/moderator/login/login-bg.png") no-repeat center;

    display: flex;
    align-items: center;
    justify-content: center;
}

.container-wrapper{
    width: 670px;
    height: 660px;

    box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.16);
    border-radius: 20px;
    background: #F1F4F5;

    display: flex;
    flex-direction: column;
    justify-content: center;
}

.container{
    padding: 0 120px;
}

.head{
    font-style: normal;
    font-weight: bold;    

    font-size: 48px;
    line-height: 56px;

    padding-bottom: 20px;

    color: #575A5D;
}

.description{
    padding: 0 70px;
    padding-bottom: 24px;
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;

    color: #575A5D;
}

.item{
    padding-bottom: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
}

.item-name{
    padding-left: 24px;
    font-weight: 500;
    font-size: 18px;
    line-height: 36px;
    color: #575A5D;
}

.item-value{
    width: 100%;
}

.text-input, .password-input {
    width: 100%;
    padding: 14px 24px;
    margin: 4px 0 0;

    box-sizing: border-box;

    font-weight: 500;
    font-size: 18px;
    line-height: 36px;
    color: #575A5D;

    background: #FFFFFF;
    box-shadow: 4px 4px 20px rgba(37, 93, 111, 0.1);
    -webkit-appearance: none;
    border: none;
    outline: none;
    border-radius: 50px;    
}

.password-input::-ms-reveal,
    input::-ms-clear {
        display: none !important;
}

.with-icon{
    position: relative;
}

.visible-block{
    position: absolute;
    top: 24px;
    right: 25px;
    z-index: 5;

    cursor: pointer;
}

.text-input:focus, .password-input:focus{
    border: 2px solid #00607E;
}

.text-input::placeholder, .password-input::placeholder {
  opacity: 0.5;
}

.enter{
    background:  linear-gradient(270.22deg, #F9A900 10.58%, #FF7DA5 140.06%);
    
    border-radius: 100px;

    width: 100%;
    color: #FFFFFF;

    padding: 14px 0;
    font-size: 24px;
    line-height: 40px;

    border: none;
    outline: none;

    cursor: pointer;

    text-align: center;
    margin-top: 40px;
}

.disabled{
    opacity: 0.3;
    background: #575A5D;
    cursor: not-allowed;
}

.error{
    input{
        border: 2px solid rgba(179, 0, 55, 0.5);
    }
}

.error-block-login{
    display: flex;
    flex-direction: row;
    align-items: center;

    padding-left: 24px;

    .icon{
        padding-right: 6px;
    }

    .text{
        p{
            font-style: normal;
            font-weight: normal;
            color: #B30037;
            font-size: 18px;
            line-height: 48px;
        }
    }
}
</style>